import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { UsersManagement } from '../../components/AdminUsers'

export const Route = createFileRoute('/admin/users')({
  component: () => (
    <UsersManagement />
  ),
})
